import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteConfirmationModal({ show, onHide, onConfirm, voteDetails, loading }) {
    const { t } = useTranslation(['voting']);
    if (!show) return null;


    const getVotePreview = (vote) => {
        if (!vote.options || vote.options.length === 0) {
            return t('voting:list.preview.noRankings');
        }
        
        const sortedOptions = [...vote.options].sort((a, b) => a.rank - b.rank);
        const topOptions = sortedOptions.slice(0, 3);
        const optionNames = topOptions.map(voteOption => 
            voteOption.name || t('voting:list.preview.unknownOption')
        );
        
        if (optionNames.length === 0) return t('voting:list.preview.noRankings');
        if (optionNames.length === 1) return t('voting:list.preview.single', { first: optionNames[0] });
        if (optionNames.length === 2) return t('voting:list.preview.double', { first: optionNames[0], second: optionNames[1] });
        return t('voting:list.preview.triple', { first: optionNames[0], second: optionNames[1], third: optionNames[2] });
    };

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('voting:deleteModal.title')}</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onHide}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-warning">
                            <strong>{t('voting:deleteModal.warning')}</strong>
                        </div>
                        
                        <p>{t('voting:deleteModal.confirmText')}</p>
                        
                        {voteDetails && (
                            <div className="vote-details bg-light p-3 rounded">
                                <div>
                                    <strong>{t('voting:deleteModal.rankingsLabel')}</strong> {getVotePreview(voteDetails)}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary" 
                            onClick={onHide}
                            disabled={loading}
                        >
                            {t('voting:deleteModal.cancel')}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-danger" 
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    {t('voting:deleteModal.deleting')}
                                </>
                            ) : (
                                t('voting:deleteModal.deleteVote')
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmationModal;